import React from 'react'
import IgniteTalksContent from '../../FunctionalComponents/IgniteTalks/IgniteTalksContent'

const IgniteTalks = ({activeAccount}) => {
  return (
    <IgniteTalksContent activeAccount={activeAccount}/>
  )
}

export default IgniteTalks